import { ShieldAlert } from "lucide-react";
import { useT } from "../lib/i18n";

export const Disclaimer = ({ compact }) => {
  const t = useT();
  return (
    <div
      data-testid="medical-disclaimer"
      className={`bg-amber-50 border-2 border-amber-300 text-amber-950 rounded-xl flex items-start gap-3 ${
        compact ? "p-3 text-sm" : "p-4 text-base"
      }`}
    >
      <ShieldAlert className="w-5 h-5 shrink-0 mt-0.5 text-amber-700" />
      <p className="leading-relaxed font-medium">{t("disclaimer_text")}</p>
    </div>
  );
};
